/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Status_AnonymisedInputs */

const cs_gdpr_status_anonymised = /** @type {(inputs: Gdpr_Status_AnonymisedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymizováno`)
};

const en_gdpr_status_anonymised = /** @type {(inputs: Gdpr_Status_AnonymisedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymised`)
};

/**
* | output |
* | --- |
* | "Anonymised" |
*
* @param {Gdpr_Status_AnonymisedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_status_anonymised = /** @type {((inputs?: Gdpr_Status_AnonymisedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Status_AnonymisedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_status_anonymised(inputs)
	return cs_gdpr_status_anonymised(inputs)
});